/**
 * Distribute integer percentage shares that always sum to 100.
 * Uses the largest-remainder method so independent rounding does not
 * produce totals like 99% or 101%.
 */
export function distributeIntegerPercents(values) {
  const safeValues = values.map((value) => Math.max(0, Number(value) || 0));
  const total = safeValues.reduce((sum, value) => sum + value, 0);

  if (total <= 0) {
    return safeValues.map(() => 0);
  }

  const exact = safeValues.map((value) => (value / total) * 100);
  const floors = exact.map((value) => Math.floor(value));
  let remainder = 100 - floors.reduce((sum, value) => sum + value, 0);

  const ranked = exact
    .map((value, index) => ({ index, remainder: value - floors[index] }))
    .sort((left, right) => right.remainder - left.remainder || left.index - right.index);

  const shares = [...floors];
  for (let step = 0; step < remainder; step += 1) {
    shares[ranked[step].index] += 1;
  }

  return shares;
}

export function sharePercentForValue(value, total) {
  const safeValue = Math.max(0, Number(value) || 0);
  const safeTotal = Math.max(0, Number(total) || 0);
  if (safeTotal <= 0) return 0;
  return (safeValue / safeTotal) * 100;
}
